import { Fetch } from 'lib';
import type { PackagingModel } from 'types';

type RequestResponses = PackagingModel;

type RequestParameters = {
  id: string;
};

const getPackagingModel = async (params: RequestParameters) =>
  await Fetch<RequestResponses>({
    url: 'adminPackagingModel/getPackagingModel',
    params,
  });

export { getPackagingModel };
